import Grid from '@mui/material/Grid';
import {
  ControlledAutoComplete,
  ControlledDatePicker,
  ControlledTimePicker
} from 'components/shared/ControlledFields';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';
import { FormHelperText, Typography } from '@mui/material';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import { useGetDutyTypes } from '../../../../queries';
import { shouldDisableDateAfterYears } from 'utils/date';
import { GridContainer } from 'components/shared/Grid/Grid.components';

const FormFields = ({ maxDate }) => {
  const { control } = useFormContext();
  const { t } = useTranslation('common', { keyPrefix: 'workPattern' });
  const { data: dutyTypes } = useGetDutyTypes();

  return (
    <>
      <MultiStepForm.Section title={t('title')}>
        <GridContainer direction="column">
          <Grid>
            <ControlledTimePicker
              fullWidth
              control={control}
              label={t('defaultMorningStartTime')}
              name="workPattern_defaultMorningStartTime"
            />
          </Grid>
          <Grid>
            <ControlledTimePicker
              fullWidth
              control={control}
              label={t('defaultAfternoonStartTime')}
              name="workPattern_defaultAfternoonStartTime"
            />
          </Grid>
          <Grid>
            <ControlledNumericField
              label={t('defaultBreakDuration')}
              name="workPattern_defaultBreakDuration"
            />
          </Grid>
          <Grid>
            <ControlledAutoComplete
              name="workPattern_defaultHolidayDutyHourType.description"
              control={control}
              label={t('defaultHolidayDutyHourType')}
              variant="outlined"
              options={dutyTypes ?? []}
              idProperty="dccCode"
              optionLabelProp="description"
              fullWidth
            />
            <FormHelperText>
              {t('defaultHolidayDutyHourTypeInfo')}
            </FormHelperText>
          </Grid>
        </GridContainer>
      </MultiStepForm.Section>
      <MultiStepForm.Section title={t('workPatternRollout.title')}>
        <Typography lineHeight={2} align="justify">
          {t('workPatternRollout.rolloutInfo')}
        </Typography>
        <ControlledDatePicker
          fullWidth
          control={control}
          label={''}
          name="workPattern_defaultRolloutEndDate"
          maxDate={maxDate}
          shouldDisableDate={shouldDisableDateAfterYears(2)}
        />
      </MultiStepForm.Section>
    </>
  );
};

export default FormFields;
